import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { hash } from './hash.js';

/* eslint-disable @sentry-internal/sdk/no-optional-chaining */

/**
 * Build the cache key for a given request
 * @param {URL | RequestInfo} resource
 * @param {RequestInit} [opts]
 */
function build_selector(resource, opts) {
  const url = JSON.stringify(resource instanceof Request ? resource.url : resource);

  let selector = `script[data-sveltekit-fetched][data-url=${url}]`;

  if (_optionalChain([opts, 'optionalAccess', _ => _.headers]) || _optionalChain([opts, 'optionalAccess', _2 => _2.body])) {
    /** @type {import('types').StrictBody[]} */
    const values = [];

    if (opts.headers) {
      // @ts-ignore - TS complains but this is a 1:1 copy of the original code and apparently it works
      values.push([...new Headers(opts.headers)].join(','));
    }

    if (opts.body && (typeof opts.body === 'string' || ArrayBuffer.isView(opts.body))) {
      values.push(opts.body);
    }

    selector += `[data-hash="${hash(...values)}"]`;
  }

  return selector;
}

export { build_selector };
//# sourceMappingURL=buildSelector.js.map
